import React from "react";
import { FaCoffee } from "react-icons/fa";
import { OrderDetail } from "../../../hooks";
import { formatOptionsForDisplay } from "./orderDetailMappings";
import { getOptionColorScheme, calculateItemTotal, formatPricePerUnit, itemCardClasses, optionTagClasses } from "./orderDetailUtils";

interface OrderItemRendererProps {
  item: OrderDetail["items"][0];
}

export const OrderItemRenderer: React.FC<OrderItemRendererProps> = ({ item }) => {
  const renderDynamicOptions = () => {
    if (!item.options || Object.keys(item.options).length === 0) {
      return null;
    }
    const formattedOptions = formatOptionsForDisplay(item.options);
    return (
      <div className="flex flex-wrap gap-2 mt-2">
        {formattedOptions.map((option, idx) => (
          <span key={option.key} className={`${optionTagClasses} ${getOptionColorScheme(idx)}`}>
            {option.label}: {option.value}
          </span>
        ))}
      </div>
    );
  };

  return (
    <div className={itemCardClasses}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-r from-green-400 to-emerald-500 rounded-xl flex items-center justify-center">
            <FaCoffee className="text-white text-sm" />
          </div>
          <div>
            <h3 className="font-bold text-gray-900 text-lg">{item.name}</h3>
            {renderDynamicOptions()}
          </div>
        </div>
        <div className="text-right">
          <p className="text-xl font-bold text-green-600">{item.quantity} adet</p>
          <p className="text-sm text-gray-600">{formatPricePerUnit(item.price)}</p>
          <p className="text-sm font-semibold text-gray-800">{calculateItemTotal(item.quantity, item.price)} ₺</p>
        </div>
      </div>
    </div>
  );
};
